import {
    Button,
    Dialog,
    DialogBody,
    DialogContainer,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    FormErrorMessage,
    Label,
    Textarea,
} from "@/shared/components";
import { Dispatch, SetStateAction, useState } from "react";

type GaatNietLeverenConfirmationDialogProps = {
    open: boolean;
    onOpenChange: Dispatch<SetStateAction<boolean>>;
    onConfirm: (toelichting: string) => void;
    initialToelichting?: string;
};

export function GaatNietLeverenConfirmationDialog({
    open,
    onOpenChange,
    onConfirm,
    initialToelichting = "",
}: GaatNietLeverenConfirmationDialogProps) {
    const [showWarning, setShowWarning] = useState(false);
    const [toelichting, setToelichting] = useState(initialToelichting);
    const hasToelichting = toelichting.trim().length > 0;

    const handleConfirm = () => {
        if (!hasToelichting) {
            setShowWarning(true);
            return;
        }

        onConfirm(toelichting.trim());
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContainer className="max-w-md">
                <DialogHeader>
                    <DialogTitle>Faciliteit gaat niet leveren</DialogTitle>
                </DialogHeader>
                <DialogBody className="grid gap-4">
                    <DialogDescription>
                        Weet je zeker dat deze faciliteit niet gaat leveren? Deze keuze kun je niet ongedaan maken.
                    </DialogDescription>
                    <div>
                        <Label htmlFor="gaat-niet-leveren-toelichting" className="mb-1">
                            Toelichting voor regievoerder
                        </Label>
                        <Textarea
                            id="gaat-niet-leveren-toelichting"
                            rows={3}
                            value={toelichting}
                            onChange={(e) => setToelichting(e.target.value)}
                        />
                    </div>
                    {showWarning && <FormErrorMessage>Voeg een toelichting toe.</FormErrorMessage>}
                </DialogBody>
                <DialogFooter>
                    <Button variant="tertiary" onClick={() => onOpenChange(false)}>
                        Annuleren
                    </Button>
                    <Button variant="primary" destructive onClick={handleConfirm}>
                        Gaat niet leveren
                    </Button>
                </DialogFooter>
            </DialogContainer>
        </Dialog>
    );
}
